/* eslint-disable */
import * as Types from '../../../../../models/schema';

import { UserFragmentDTO } from '../../../../../graphql/models/fragments';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions =  {}
export type GetUserVariablesDTO = Types.Exact<{
  id: Types.Scalars['String'];
}>;


export type GetUserDTO = (
  { __typename?: 'Query' }
  & { user: (
    { __typename?: 'User' }
    & UserFragmentDTO
  ) }
);


export const GetUserDocumentDTO = gql`
    query getUser($id: String!) {
  user(id: $id) {
    ...userFragment
  }
}
    ${UserFragmentDTO}`;

/**
 * __useGetUser__
 *
 * To run a query within a React component, call `useGetUser` and pass it any options that fit your needs.
 * When your component renders, `useGetUser` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUser({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUser(baseOptions: Apollo.QueryHookOptions<GetUserDTO, GetUserVariablesDTO>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserDTO, GetUserVariablesDTO>(GetUserDocumentDTO, options);
      }
export function useGetUserLazyQueryDTO(baseOptions?: Apollo.LazyQueryHookOptions<GetUserDTO, GetUserVariablesDTO>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserDTO, GetUserVariablesDTO>(GetUserDocumentDTO, options);
        }
export type GetUserHookResult = ReturnType<typeof useGetUser>;
export type GetUserLazyQueryDTOHookResult = ReturnType<typeof useGetUserLazyQueryDTO>;
export type GetUserQueryResultDTO = Apollo.QueryResult<GetUserDTO, GetUserVariablesDTO>;